import { useTranslation } from 'react-i18next';

import type { Company } from '../../../domain/company';
import { Metric } from '../Metric';
import { SectionHeader } from '../SectionHeader';
import { StyledSectionView } from '../styles';

import { StyledMetricsContainer } from './styles';

export const Engagement = ({ company }: { company: Company }) => {
  const { t } = useTranslation();
  return (
    <StyledSectionView data-automation="EngagementSection" withPadding>
      <SectionHeader
        withSectionPadding
        title={t('company.engagement')}
        dateInfo={t<string>('company.engagement.date_info', { monthNumber: 3 })}
        websource="all"
        showWorldwideIcon
      />
      <StyledMetricsContainer data-automation="EngagementMetric">
        <Metric
          name={t('company.traffic_and_engagement.pages_per_visit')}
          value={company.pagesPerVisit}
          format="number"
          iconName="pages-per-visit"
        />
        <Metric
          name={t('company.traffic_and_engagement.bounce_rate')}
          value={company.bounceRate}
          format="percentage"
          iconName="bounce-rate-2"
        />
        <Metric
          name={t('company.traffic_and_engagement.avg_visit_duration')}
          value={company.avgVisitDuration}
          format="time"
          iconName="daily-usage-per-user"
        />
      </StyledMetricsContainer>
    </StyledSectionView>
  );
};
